import { useState } from "react";
import { useAuth } from "../../../context/contextAuth";
import { getUrlResults } from "../../../api/get/aws/get-url";
import { scanS3Url } from "../../../api/post/post-aws";

const useAwsUrl = () => {
  const { userId, user } = useAuth();

  // MAIN STATES
  const [webLoading, setWebLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [error, setError] = useState(null);

  // RESULTS FROM BACKEND
  const [webResults, setWebResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // TABLES FOR UI
  const [urlVulTable, setUrlVulTable] = useState([]);
  const [urlEpssTable, setUrlEpssTable] = useState([]);

  // SCORE DATA
  const [TVulScore, setTVulScore] = useState(0);
  const [CVulScore, setCVulScore] = useState(0);
  const [saveScore, setSaveScore] = useState(0);
  const [auditResult, setAuditResult] = useState("");

  // DASHBOARD CONTROL FLAGS
  const [urlScanLoading, setUrlScanLoading] = useState(false);
  const [urlDashboardView, setUrlDashboardView] = useState(false);
  const [urlHeader, setUrlHeader] = useState(false);

  const initData = async () => {
    if (!user) {
      resetState();
      return;
    }

    await fetchWebResults(userId);
    if(!urlScanLoading) await loadWebData(0);
  };

  const fetchWebResults = async (userId) => {
    try {
      const results = await getUrlResults(userId);
      setWebResults(results);
      if (results.length > 0) setUrlDashboardView(true);
      return results;
    } catch (error) {
      console.error("Error fetching results:", error);
      setWebResults([]);
      return [];
    }
  };

  const loadWebData = async (index) => {
    const scan = webResults[index];
    if (!scan) return;

    setCurrentIndex(index);
    setUrlVulTable(scan.vuln_data || []);
    setUrlEpssTable(scan.epss_data || []);
    setTVulScore(scan.t_vul);
    setCVulScore(scan.c_vul);
    setSaveScore(scan.ss);
    setAuditResult(scan.vuln_data || []);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setUrlScanLoading(true);
    setUrlDashboardView(true);
    setUrlHeader(false);

    try {
      await scanS3Url(userId, url);
      const results = await fetchWebResults(userId);
      await loadWebData(results.length - 1);
    } catch (err) {
      setUrlDashboardView(false);
      setError({
        message: err.message,
        card: err.card || false
      });
    } finally {
      setUrlScanLoading(false);
      setUrlHeader(true);
      setUrl("");
      setTimeout(() => setError(null), 5000);
    }
  };

  const resetState = () => {
    setWebLoading(false);
    setUrl("");
    setError(null);

    setWebResults([]);
    setCurrentIndex(0);

    setUrlVulTable([]);
    setUrlEpssTable([]);

    setTVulScore(0);
    setCVulScore(0);
    setSaveScore(0);
    setAuditResult("");

    setUrlScanLoading(false);
    setUrlDashboardView(false);
    setUrlHeader(false);
  };
  
  return {
    // states
    webLoading,
    url,
    error,

    webResults,
    currentIndex,
    urlVulTable,
    urlEpssTable,

    TVulScore,
    CVulScore,
    saveScore,
    auditResult,

    urlScanLoading,
    urlDashboardView,
    urlHeader,

    // setters
    setUrl,
    setCurrentIndex,
    setUrlDashboardView,
    setUrlHeader,

    // functions
    initData,
    loadWebData,
    handleSubmit,
    resetState,
  };
};

export default useAwsUrl;
